import React from "react";
import { Router } from "@reach/router";
import ManagerLogin from "./components/pages/ManagerLogin";
import DashboardScreens from "./components/pages/DashboardScreens";
// import MyTasks from "./components/pages/MyTasks";
import PendingActions from "./components/internal/PendingActions";
import Uploads from "./components/internal/Uploads";
import VerifyDetails from "./components/internal/VerifyDetails";
import LoginPath from "./components/pages/ManagerLogin/LoginPath";
import PartyDetails from "./components/internal/PartyDetails";
import MyCases from "./components/internal/MyCases";
import MyProfiles from "./components/internal/MyProfiles";
import CaseDetails from "./components/pages/CaseDetails";
// import Configurations from "./components/pages/Configurations";
// import MyConfigurations from "./components/internal/MyConfigurations";
// import UpdateTerminologies from "./components/internal/UpdateTerminologies";
// import UpdateFAQs from "./components/pages/UpdateFAQs";
import ProfileDetails from "./components/pages/ProfileDetails";
import BulkUploads from "./components/pages/BulkUploads";
import Parties from "./components/internal/MyParties";
import MailRedirection from "./components/pages/MailRedirection";
import ProformaInvoiceListing from "./components/internal/ProformaInvoiceListing";
import PaymentHistoryPage from "./components/internal/PaymentHistoryPage";
import RecordingsPage from "./components/internal/RecordingsPage/index";
import GuestGenericMeeting from "./components/pages/JoinGenericMeeting";
import TimeSlideTranscription from "./components/pages/TimeSlideTranscription/index";
import RecordingsTimeSlide from "./components/pages/RecordingsTimeSlide";
import LiveTranscription from "./components/internal/TimeSlideTranscript/LiveTranscription";
import TranscriberTable from "./components/internal/TranscriberTable";
import ViewTranscriber from "./components/internal/ViewTranscriber/index";
import CreateTranscriber from "./components/internal/CreateTranscriber/index";
import EditTranscriber from "./components/internal/EditTranscriber/EditTranscriber";
import ChangePassword from "./components/pages/ChangePassword/index";
import AudioTranscription from "./components/pages/TimeSlideTranscription/AudioTranscription";
import MeetingDetails from "./components/pages/MeetingDetails/index";
import SessionManagement from "./components/pages/SessionManagement";
import CrossExamination from "./components/internal/CrossExamination/index";
import CrossExaminationTranscript from "./components/internal/CrossExamination/CrossExaminationTranscripts";
// import NeutralView from "./components/pages/NeutralView/index";
// import NeutralViewTable from "./components/internal/NeutralViewTable/index";
// import CreateNeutral from "./components/internal/CreateNeutral/index";
// import EditNeutral from "./components/internal/EditNeutral/index";
// import ViewNeutral from "./components/internal/ViewNeutral";
import ViewOnlyUser from "./components/internal/ViewOnlyUser/index";
import CreateViewOnlyUser from "./components/internal/ViewOnlyUser/CreateViewOnlyUser";
import UpdateViewOnlyUser from "./components/internal/ViewOnlyUser/UpdateViewOnlyUser";
import BulkNotice from "./components/internal/NoticeGeneration";
// import DailyCause from "./components/internal/DailyCause/index";
import DailyCause from "./components/calender/DailyCause";
import MisDashboard from "./components/Mis/MisDashboard.js";
import ViewCases from "./components/ViewCases";
import ManagementTools from "./components/internal/ManagementTools";
import UpdateArbitratorsInfo from "./components/pages/UpdateArbitratorsInfo";
import UpdateMediatorsInfo from "./components/pages/UpdateMediatorsInfo";

/* Bulk upload reports */
import BulkUploadReports from "./components/internal/BulkUploadReports/index.js";
import MainRoute from "./components/pages/MainRoute/index.js";
import FieldMapping from "./components/internal/Field Mapping/index.js";
import FinalApprover from "./components/internal/FinalApprover/index.js";
import NeutralMeeting from "./components/internal/NeutalMeeting/index.js";
import ArbitratorJoinMeeting from "./components/pages/ArbitratorJoinMeeting.js";
import ArbitratorMeeting from "./components/pages/ArbitratorMeeting.js";
import EsignerTable from "./components/internal/EsignerTable/index.js";
import RoutingTracker from "./components/internal/Tracking/index.js";
import Transcription from "./components/internal/TranscriberTable/Transcription.js";
import TranscriptionDetails from "./components/pages/MeetingDetails/TranscriptionDetails.js";
import CommsManager from "./components/internal/CommsManager";
import Communication from "./components/internal/CommsManager/Communication.js";
import Logs from "./components/internal/CommsManager/Logs.js";
import WhatsappLogs from "./components/internal/CommsManager/WhatsappLogs.js";
import SmsLogs from "./components/internal/CommsManager/SmsLogs.js";
import BookingDashboard from "./components/booking_dashboard/index.js";
import BookingsPage from "./components/booking_dashboard/Bookings/index.js";
import CalendarPage from "./components/booking_dashboard/Calendar/index.js";
import WalkinBookingPage from "./components/booking_dashboard/WalkinBooking/index.js";
import InvoicesPage from "./components/booking_dashboard/Invoices/index.js";
import ReportsPage from "./components/booking_dashboard/Reports/index.js";
import PricingUpload from "./components/internal/Pricing/index.js";

const AppRouter = () => {
  return (
    <Router>
      <LoginPath path="/">
        <ManagerLogin path="/" />
      </LoginPath>
      <DashboardScreens path="/dashboard">
        <MainRoute path="/case-manager">
          <ChangePassword path="/change-password" />
          <PendingActions path="/" />
          <ProformaInvoiceListing path="/proforma-invoice" />
          <Uploads path="/uploads" />
          <VerifyDetails path="/verify-parties" />
          <PartyDetails path="/verify-parties/:partyId" />
          <BulkNotice path="/bulk-notice" />
          <BulkUploadReports path="/document-reports" />

          {/* Negotiation Route */}

          <MyCases path="/negotiation" type="negotiation" />
          <CaseDetails path="/negotiation/:id/*" />
          <CaseDetails path="/negotiation/:id" />

          {/* Mediation Route  */}

          <MyCases path="/mediation" type="mediation" />
          <CaseDetails path="/mediation/:id/*" />
          <CaseDetails path="/mediation/:id" />
          <TimeSlideTranscription
            path="/mediation/:id/transcription"
            type="mediation"
          />
          <AudioTranscription
            path="/mediation/:id/split-transcription"
            type="mediation"
          />
          <LiveTranscription
            path="/mediation/:id/livetranscription"
            type="mediation"
          />
          <CrossExamination
            path="/mediation/:id/cross-examination"
            type="mediation"
          />
          <CrossExaminationTranscript
            path="/mediation/:id/cross-examination-transcript"
            type="mediation"
          />

          {/* Arbitration Route */}

          <MyCases path="/arbitration" type="arbitration" />
          <CaseDetails path="/arbitration/:id/*" />
          <CaseDetails path="/arbitration/:id" />
          <ViewCases path="/arbitration/view/:id" />
          <TimeSlideTranscription
            path="/arbitration/:id/transcription"
            type="arbitration"
          />
          <AudioTranscription
            path="/arbitration/:id/split-transcription"
            type="arbitration"
          />
          <LiveTranscription
            path="/arbitration/:id/livetranscription"
            type="arbitration"
          />
          <CrossExamination
            path="/arbitration/:id/cross-examination"
            type="arbitration"
          />
          <CrossExaminationTranscript
            path="/arbitration/:id/cross-examination-transcript"
            type="arbitration"
          />

          <Parties path="/parties" />
          <CommsManager path="/comms-manager" />
          <Communication path="/comms-manager/communication" />
          <Logs path="/comms-manager/logs" />
          <WhatsappLogs path="/comms-manager/whatsapp-logs" />
          <SmsLogs path="/comms-manager/sms-logs" />
          <PartyDetails path="/parties/:partyId" isFromListing={true} />

          <MyProfiles path="/profiles" />
          <ProfileDetails path="/profiles/:userId" />
          <CreateViewOnlyUser path="/profiles/create-view-only-user" />
          <ViewOnlyUser path="/profiles/view-only-user/:id" />
          <UpdateViewOnlyUser path="/profiles/edit/:id" />

          <BulkUploads path="/bulk-uploads" />

          <PaymentHistoryPage path="/payments" />
          <RecordingsPage path="/generic-meeting" />
          <RecordingsTimeSlide path="/generic-meeting/transcription" />
          <MeetingDetails path="/meeting-details" />
          <NeutralMeeting path="/neutral-meeting-details" />
          <SessionManagement path="/meeting-details/session-management" />
          <TranscriptionDetails path="/meeting-details/transcription" />
          <DailyCause path="/daily-cause" />
          <TranscriberTable path="/transcriber" />
          <CreateTranscriber path="/transcriber/create-transcriber" />
          <Transcription path="/transcriber/transcription" />
          <EditTranscriber path="/transcriber/edit/:id" />
          <ViewTranscriber path="/transcriber/:id" />
          <FieldMapping path="/field-mapping" />
          <MisDashboard path="/mis-dashboard" />
          <ManagementTools path="/tools" />
          <UpdateArbitratorsInfo path="/tools/arbitrators" />
          <UpdateMediatorsInfo path="/tools/mediators" />
          <FinalApprover path="/final-approver" />
          <EsignerTable path="/esigner" />
          <RoutingTracker path="/tracking" />
          <BookingDashboard path="/booking-dashboard" />
          <BookingsPage path="/booking-dashboard/bookings" />
          <CalendarPage path="/booking-dashboard/calendar" />
          <WalkinBookingPage path="/booking-dashboard/walkin" />
          <InvoicesPage path="/booking-dashboard/invoices" />
          <ReportsPage path="/booking-dashboard/reports" />
          <PricingUpload path="/pricing" />
        </MainRoute>
        <MailRedirection path="/cases/:id" redirectTo="case" />
      </DashboardScreens>
      <GuestGenericMeeting path="/joinMeeting/:code" />
      <ArbitratorJoinMeeting path="/joinMeeting/arbitrator" />
      <ArbitratorMeeting path="/joinMeeting/arbitrator/:code" />
    </Router>
  );
};

export default AppRouter;
